import PropTypes from 'prop-types';
import { UserRoles as roles } from '../../constants/enums';

export const RolesShape = PropTypes.arrayOf(PropTypes.oneOf(Object.values(roles)));

export const AccountShape = PropTypes.shape({
  accountId: PropTypes.string.isRequired,
  subscriptionId: PropTypes.string.isRequired,
  iamRegion: PropTypes.string,
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  /* [SIC](https://dev-developers.smartsparrow.com/data-transfer-objects/account-dto/) */
  honorifixPrefix: PropTypes.string,
  primaryEmail: PropTypes.string,
  roles: RolesShape,
  email: PropTypes.arrayOf(PropTypes.string),
  avatarSmall: PropTypes.string,
});
